import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { Chat } from '@/models/chat';

/**
 * Select the current chat entity
 */
export const selectCurrentChat = createSelector(
  [
    (state: RootState) => state.ChatReducer.currentChatId,
    (state: RootState) => state.DBChatReducer.entities
  ],
  (currentChatId, entities) => {
    if (!currentChatId) return null;
    return (entities[currentChatId] as Chat) || null;
  }
);

